// extracted by css-extract-rspack-plugin
export default {"form":"ZPg2Ub3GDEtZN8Cl","item":"sCtuuchjj1w7JPu0","display_none":"kuNmnSvRP0k5EZJS","input":"fKQcMgwrrv4bCXiB","multi_select_wrapper":"CIA1XtOMj34v3ZLt"};